// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-container {
  background-color: white;
  /* border-radius: 5px; */
  padding: 3em;
  max-width: 75%;
  margin: auto;
  box-shadow: 0.5px 0.5px 3.5em -25px slategrey;
  display: flex;
  flex-direction: column;
  animation: slide-fade-in 300ms ease-out;
  position: inherit;
}

.d--flex {
  max-width: 100%;
  display: flex;
  flex-flow: column;
}

input[name=inputemailAddress],
input[name=confirmEmailAddress],
input[name=dob],
.datepicker__wrapper .picker-input input.picker-input__text {
  font-weight: 400;
  font-size: 13.3333px;
  max-width: 100%;
  padding: 1rem;
  padding-left: 0 !important;
  padding-bottom: 0.5rem;
  border: none;
  outline: 0px;
  width: 100%;
  margin-right: 0;
  display: block;
  border-bottom: 1px solid slategrey;
}

input[name=inputemailAddress]:focus,
input[name=inputemailAddress]:active,
input[name=dateOfBirth]:focus,
input[name=dateOfBirth]:active,
input[name=confirmEmailAddress]:focus,
input[name=confirmEmailAddress]:active,
.datepicker__wrapper .picker-input__text:active,
.datepicker__wrapper .picker-input__text:focus {
  outline: 0;
  border-bottom: 2px solid #007c92;
  transition: border-bottom 0.2s cubic-bezier(0.39, 0.575, 0.565, 1);
}

.form__input--error,
.form__input--error:focus,
.form__input--error:active {
  max-width: 100%;
  padding: 1rem;
  padding-left: 0;
  padding-bottom: 0.5rem;
  border: none;
  border-bottom: 2px solid #e60000 !important;
  transition: border-bottom 0.2s ease;
}

@keyframes slide-fade-in {
  from {
    transform: translateX(-10%);
    opacity: 0;
  }
  to {
    transform: translateX(0%);
    opacity: 1;
  }
}
@keyframes slide-fade-out {
  from {
    transform: translateX(0%);
    opacity: 1;
  }
  to {
    transform: translateX(10%);
    opacity: 0;
  }
}
.hide {
  animation: slide-fade-out 300ms ease-out;
}

.email-form {
  flex: 1 0 50%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 100%;
  width: 100%;
}

.img-container {
  flex: 1 0 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;
}

.form-label {
  display: block;
  font-size: 1em;
  margin: 1.5em 0 0.5em 0;
}

.form-field {
  max-width: 100%;
  padding: 1rem;
  padding-left: 0;
  padding-bottom: 0.5rem;
  border: 0;
  outline: 0;
  border-bottom: 1px solid slategrey;
}

.form-field:focus,
.form-field:active {
  outline: 0;
  border-bottom: 1px solid #e60000;
  transition: border-bottom 0.5s cubic-bezier(0.39, 0.575, 0.565, 1);
}

.form-error {
  color: #e60000;
}

.form-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 1rem 0;
  flex-direction: column-reverse;
}

.react-datepicker__triangle {
  display: none !important;
}

@media screen and (min-width: 768px) {
  .form-wrapper {
    flex-direction: row;
  }
  input[name=inputemailAddress],
  input[name=confirmEmailAddress],
  input[name=dob] {
    width: 36ch;
  }
}
strong {
  color: #e60000;
  font-size: 1rem;
  width: 100%;
}

p {
  line-height: 1.5em;
  margin: 0px;
  font-size: 0.875rem;
}

.disable {
  cursor: not-allowed;
  background: slategrey !important;
  color: lightgray !important;
}

.btn:hover {
  background: #e60000;
}

.email--button {
  display: table;
  width: 100%;
  margin: 0;
  margin-bottom: 1rem;
  margin-top: 2rem;
}

.datepicker__wrapper {
  max-width: 100%;
  display: flex;
  flex-flow: column;
}

/* style date picker skin for VF */
.datepicker__wrapper .calendar__head {
  background: var(--vodafone-dark-red);
}

.datepicker__wrapper .calendar__day--start,
.datepicker__wrapper .calendar__day--end,
.datepicker__wrapper .calendar__day--selected {
  background: #e60000;
  font-weight: bold;
}

.datepicker__wrapper .calendar__panel--today {
  background: var(--vodafone-dark-red);
  border-top: 1px solid white;
  color: white;
}

.datepicker__wrapper .calendar__day {
  height: 30px;
  vertical-align: inherit;
}

.datepicker__wrapper .calendar__year:hover,
.datepicker__wrapper .calendar__month:hover,
.datepicker__wrapper .calendar__day:hover:not(.calendar__day--disabled),
.datepicker__wrapper .calendar__day--selected:hover {
  background: #ffffff;
  outline: 2px solid #820000;
  font-weight: bold;
  color: black;
}

.datepicker__wrapper .calendar__day--0,
.datepicker__wrapper .calendar__day--6 {
  color: #820000;
}

.react-datepicker__month {
  background-color: white;
}

.react-datepicker {
  box-shadow: 0px 0px 20px 1px var(--vodafone-grey);
}

.react-datepicker__header {
  background-color: var(--vodafone-dark-red) !important;
  font-family: "Vodafone Rg", Arial, Helvetica, sans-serif;
}
.react-datepicker__header > * {
  color: white !important;
}
.react-datepicker__header > * > .btn {
  margin: 0 2px;
  box-shadow: 0 0 2px 0 red;
  background-color: transparent;
}
.react-datepicker__header > * > .btn:hover {
  background-color: var(--vodafone-red);
  transition: all 300ms ease;
}

.react-datepicker__day-name {
  color: white !important;
}

.controls-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.react-datepicker__day--selected {
  background-color: var(--vodafone-dark-red);
}

.email-btn-disabled {
  background-color: var(--vodafone-slate-grey);
}

.calendar-main-div {
  position: absolute;
  top: 1rem;
  margin: 2rem 0;
  cursor: pointer;
  padding: 0%;
  max-height: 15rem;
  width: 15ch;
  overflow-x: hidden;
  overflow-y: scroll;
  border-radius: 5px;
  scroll-behavior: smooth;
  box-shadow: 0px 0px 15px 1px var(--vodafone-slate-grey);
  animation: zoom 300ms ease-in;
}
.calendar-main-div::-webkit-scrollbar {
  width: 5px;
  border-radius: 5px;
}
.calendar-main-div::-webkit-scrollbar-track {
  background-color: var(--vodafone-slate-grey);
}
.calendar-main-div::-webkit-scrollbar-thumb {
  background-color: var(--vodafone-red);
  border-radius: 5px;
}

.calendar-options {
  padding: 0.5rem;
  box-shadow: 0px 0px 1px 0px var(--vodafone-slate-grey);
  background-color: var(--vodafone-white);
  color: var(--vodafone-slate-grey) !important;
  transition: all 300ms ease;
  font-size: 1rem;
}
.calendar-options:hover {
  background-color: var(--vodafone-slate-grey);
  color: var(--vodafone-white) !important;
}

.hide {
  display: none;
}

@keyframes zoom {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/email/emailStyles.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,wBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,aAAA;EACA,iBAAA;AACJ;;AAEA;;;;EAKI,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,0BAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,kCAAA;AAAJ;;AAGA;;;;;;;;EASI,UAAA;EACA,gCAAA;EACA,kEAAA;AADJ;;AAIA;;;EAGI,eAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,2CAAA;EACA,mCAAA;AADJ;;AAMA;EACI;IACI,2BAAA;IACA,UAAA;EAHN;EAME;IACI,yBAAA;IACA,UAAA;EAJN;AACF;AAOA;EACI;IACI,yBAAA;IACA,UAAA;EALN;EAQE;IACI,0BAAA;IACA,UAAA;EANN;AACF;AASA;EACI,wCAAA;AAPJ;;AAUA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AAPJ;;AAUA;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAPJ;;AA4BA;EACI,cAAA;EACA,cAAA;EACA,uBAAA;AAzBJ;;AA4BA;EACI,eAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,kCAAA;AAzBJ;;AA4BA;;EAEI,UAAA;EACA,gCAAA;EACA,kEAAA;AAzBJ;;AA4BA;EACI,cAAA;AAzBJ;;AA4BA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,8BAAA;AAzBJ;;AA4BA;EACI,wBAAA;AAzBJ;;AA4BA;EACI;IACI,mBAAA;EAzBN;EA4BE;;;IAGI,WAAA;EA1BN;AACF;AA6BA;EACI,cAAA;EACA,eAAA;EACA,WAAA;AA3BJ;;AA8BA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;AA3BJ;;AA8BA;EACI,mBAAA;EACA,gCAAA;EACA,2BAAA;AA3BJ;;AA8BA;EACI,mBAAA;AA3BJ;;AA8BA;EACI,cAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AA3BJ;;AA+BA;EACI,eAAA;EACA,aAAA;EACA,iBAAA;AA5BJ;;AA+BA,kCAAA;AACA;EAEI,oCAAA;AA7BJ;;AAgCA;;;EAGI,mBAAA;EACA,iBAAA;AA7BJ;;AAgCA;EACI,oCAAA;EACA,2BAAA;EACA,YAAA;AA7BJ;;AAgCA;EACI,YAAA;EACA,uBAAA;AA7BJ;;AAgCA;;;;EAKI,mBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;AA9BJ;;AAiCA;;EAEI,cAAA;AA9BJ;;AAiCA;EACI,uBAAA;AA9BJ;;AAiCA;EACI,iDAAA;AA9BJ;;AAkCA;EACI,qDAAA;EACA,wDAAA;AA/BJ;AAgCI;EACI,uBAAA;AA9BR;AA+BQ;EACI,aAAA;EACA,yBAAA;EACA,6BAAA;AA7BZ;AA8BY;EACI,qCAAA;EACA,0BAAA;AA5BhB;;AAkCA;EACI,uBAAA;AA/BJ;;AAmEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAhEJ;;AAmEA;EACI,0CAAA;AAhEJ;;AAyEA;EACI,4CAAA;AAtEJ;;AAyEA;EACI,kBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,uDAAA;EACA,6BAAA;AAtEJ;AAuEI;EACI,UAAA;EACA,kBAAA;AArER;AAuEI;EACI,4CAAA;AArER;AAuEI;EACI,qCAAA;EACA,kBAAA;AArER;;AAyEA;EACI,eAAA;EACA,sDAAA;EACA,uCAAA;EACA,4CAAA;EACA,0BAAA;EACA,eAAA;AAtEJ;AAuEI;EACI,4CAAA;EACA,uCAAA;AArER;;AAyEA;EACI,aAAA;AAtEJ;;AAyEA;EACI;IAAI,UAAA;EArEN;EAsEE;IAAK,UAAA;EAnEP;AACF","sourcesContent":[".email-container {\n    background-color: white;\n    /* border-radius: 5px; */\n    padding: 3em;\n    max-width: 75%;\n    margin: auto;\n    box-shadow: 0.5px 0.5px 3.5em -25px slategrey;\n    display: flex;\n    flex-direction: column;\n    animation: slide-fade-in 300ms ease-out;\n    position: inherit;\n}\n\n.d--flex{\n    max-width: 100%;\n    display: flex;\n    flex-flow: column;\n}\n\ninput[name=\"inputemailAddress\"],\ninput[name=\"confirmEmailAddress\"],\ninput[name=\"dob\"],\n.datepicker__wrapper .picker-input input.picker-input__text\n{\n    font-weight: 400 ;\n    font-size: 13.3333px;\n    max-width: 100%;\n    padding: 1.0rem;\n    padding-left: 0 !important;\n    padding-bottom: 0.5rem;\n    border: none;\n    outline: 0px;\n    width: 100%;\n    margin-right:0;\n    display: block;\n    border-bottom: 1px solid slategrey;\n}\n\ninput[name=\"inputemailAddress\"]:focus,\ninput[name=\"inputemailAddress\"]:active,\ninput[name=\"dateOfBirth\"]:focus,\ninput[name=\"dateOfBirth\"]:active,\ninput[name=\"confirmEmailAddress\"]:focus,\ninput[name=\"confirmEmailAddress\"]:active,\n.datepicker__wrapper .picker-input__text:active,\n.datepicker__wrapper .picker-input__text:focus\n{\n    outline: 0;\n    border-bottom: 2px solid #007c92;\n    transition: border-bottom 0.2s cubic-bezier(0.39, 0.575, 0.565, 1);\n}\n\n.form__input--error,\n.form__input--error:focus,\n.form__input--error:active {\n    max-width: 100%;\n    padding: 1.0rem;\n    padding-left: 0;\n    padding-bottom: 0.5rem;\n    border: none;\n    border-bottom: 2px solid #e60000 !important;\n    transition: border-bottom 0.2s ease;\n\n\n}\n\n@keyframes slide-fade-in {\n    from {\n        transform: translateX(-10%);\n        opacity: 0;\n    }\n\n    to {\n        transform: translateX(0%);\n        opacity: 1;\n    }\n}\n\n@keyframes slide-fade-out {\n    from {\n        transform: translateX(0%);\n        opacity: 1;\n    }\n\n    to {\n        transform: translateX(10%);\n        opacity: 0;\n    }\n}\n\n.hide {\n    animation: slide-fade-out 300ms ease-out;\n}\n\n.email-form {\n    flex: 1 0 50%;\n    display: flex;\n    flex-direction: column;\n    margin: 0 auto;\n    max-width: 100%;\n    width: 100%;\n}\n\n.img-container {\n    flex: 1 0 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 1.0rem 0;\n    // & img{\n    //     // width: 100px;\n    // }\n}\n\n// .img-container img {\n//     width: 100px;\n// }\n\n\n// .brutalll{\n//     background: orange;\n//     height: 40px;\n//     width: 50px;\n\n// }\n// .brutalll:hover{\n//     background: #e60000;\n// }\n\n.form-label {\n    display: block;\n    font-size: 1em;\n    margin: 1.5em 0 0.5em 0;\n}\n\n.form-field {\n    max-width: 100%;\n    padding: 1.0rem;\n    padding-left: 0;\n    padding-bottom: 0.5rem;\n    border: 0;\n    outline: 0;\n    border-bottom: 1px solid slategrey;\n}\n\n.form-field:focus,\n.form-field:active {\n    outline: 0;\n    border-bottom: 1px solid #e60000;\n    transition: border-bottom 0.5s cubic-bezier(0.39, 0.575, 0.565, 1);\n}\n\n.form-error {\n    color: #e60000;\n}\n\n.form-wrapper {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    margin: 1.0rem 0;\n    flex-direction: column-reverse\n}\n\n.react-datepicker__triangle{\n    display: none !important;\n}\n\n@media screen and (min-width: 768px) {\n    .form-wrapper {\n        flex-direction: row;\n    }\n\n    input[name=\"inputemailAddress\"],\n    input[name=\"confirmEmailAddress\"],\n    input[name=\"dob\"]{\n        width: 36ch;\n    }\n}\n\nstrong {\n    color: #e60000;\n    font-size: 1rem;\n    width: 100%;\n}\n\np {\n    line-height: 1.5em;\n    margin: 0px;\n    font-size: 0.875rem;\n}\n\n.disable {\n    cursor: not-allowed;\n    background: slategrey !important;\n    color: lightgray !important;\n}\n\n.btn:hover  {\n    background: #e60000;\n}\n\n.email--button {\n    display: table;\n    width: 100%;\n    margin: 0;\n    margin-bottom: 1.0rem;\n    margin-top: 2.0rem;\n\n    \n}\n.datepicker__wrapper{\n    max-width: 100%;\n    display: flex;\n    flex-flow: column;\n}\n\n/* style date picker skin for VF */\n.datepicker__wrapper .calendar__head{\n \n    background: var(--vodafone-dark-red);\n}\n \n.datepicker__wrapper .calendar__day--start, \n.datepicker__wrapper .calendar__day--end, \n.datepicker__wrapper .calendar__day--selected {\n    background: #e60000;\n    font-weight: bold;\n}\n\n.datepicker__wrapper .calendar__panel--today{\n    background: var(--vodafone-dark-red);\n    border-top: 1px solid white;\n    color: white;\n}\n\n.datepicker__wrapper .calendar__day{\n    height: 30px;\n    vertical-align: inherit;\n}\n\n.datepicker__wrapper .calendar__year:hover, \n.datepicker__wrapper .calendar__month:hover,\n.datepicker__wrapper .calendar__day:hover:not(.calendar__day--disabled),\n.datepicker__wrapper .calendar__day--selected:hover\n{\n    background: #ffffff;\n    outline: 2px solid  #820000;\n    font-weight: bold;\n    color: black;\n}\n\n.datepicker__wrapper .calendar__day--0,\n.datepicker__wrapper .calendar__day--6 {\n    color: #820000;\n}\n\n.react-datepicker__month{\n    background-color: white;\n}\n\n.react-datepicker{\n    box-shadow: 0px 0px 20px 1px var(--vodafone-grey);\n    \n}\n\n.react-datepicker__header {\n    background-color: var(--vodafone-dark-red) !important;\n    font-family:  \"Vodafone Rg\", Arial, Helvetica, sans-serif;\n    & > *{\n        color: white !important;\n        & > .btn{\n            margin: 0 2px;\n            box-shadow: 0 0 2px 0 red;\n            background-color: transparent;\n            &:hover{\n                background-color: var(--vodafone-red);\n                transition: all 300ms ease;\n            }\n        }\n    }\n}\n\n.react-datepicker__day-name{\n    color: white !important;\n}\n\n// .next-month{\n//     border: none;\n//     outline: 0px;\n//     background-color: var(--vodafone-dark-red);\n//     height: 2rem;\n//     width: 2rem;\n//     font-size: x-large;\n//     cursor: pointer;\n// }\n\n// .next-month:hover{\n//     background-color: var(--vodafone-dark-red);\n//     transition: all 330ms ease;\n// }\n\n// .select-year {\n//     cursor: pointer;\n//     background-color: var(--vodafone-dark-red);\n//     border: none;\n//     border-bottom: 1px solid var(--vodafone-dark-red);\n//     outline: 0px;\n// }\n\n// .select-year::-webkit-scrollbar {\n//     display: none;\n//   }\n  \n//   /* Hide scrollbar for IE, Edge and Firefox */\n//   .select-year {\n//     -ms-overflow-style: none;  /* IE and Edge */\n//     scrollbar-width: none;  /* Firefox */\n//   }\n\n.controls-container{\n    display: flex;\n    justify-content: space-between;\n    align-items:center;\n}\n\n.react-datepicker__day--selected{\n    background-color: var(--vodafone-dark-red);\n}\n\n// .react-datepicker__header select {\n//     -webkit-appearance: none;\n//     -moz-appearance: none;\n// }\n\n\n.email-btn-disabled {\n    background-color: var(--vodafone-slate-grey);\n  }\n\n.calendar-main-div{\n    position: absolute;\n    top: 1rem;\n    margin: 2rem 0;\n    cursor: pointer;\n    padding: 0%;\n    max-height: 15rem;\n    width: 15ch;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    border-radius: 5px;\n    scroll-behavior: smooth;\n    box-shadow: 0px 0px 15px 1px var(--vodafone-slate-grey);\n    animation: zoom 300ms ease-in;\n    &::-webkit-scrollbar{\n        width: 5px;\n        border-radius: 5px;\n    }\n    &::-webkit-scrollbar-track{\n        background-color: var(--vodafone-slate-grey);\n    }\n    &::-webkit-scrollbar-thumb{\n        background-color: var(--vodafone-red);\n        border-radius: 5px;\n    }\n}\n\n.calendar-options{\n    padding: 0.5rem;\n    box-shadow: 0px 0px 1px 0px var(--vodafone-slate-grey);\n    background-color: var(--vodafone-white);\n    color: var(--vodafone-slate-grey) !important;\n    transition: all 300ms ease;\n    font-size: 1rem;\n    &:hover{\n        background-color: var(--vodafone-slate-grey);\n        color: var(--vodafone-white) !important;\n    }\n}\n\n.hide{\n    display: none;\n}\n\n@keyframes zoom {\n    0%{ opacity:0}\n    100%{opacity:1}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
